import { SimpleModel } from 'model/SimpleModel';

import { DiscreteQuestion } from './DiscreteQuestion';
import { PageItem } from './PageItem';
import { PageItemKind } from './PageItemKind';
import { Question } from './Question';

export namespace Page {
  export interface Shape {
    project?: number;
    id?: number;
    position?: number;
    items?: PageItem[];
  }
}

export class Page extends SimpleModel<Page.Shape> {
  getProject(): number {
    return this.get('project');
  }

  getId(): number {
    return this.get('id');
  }

  getPosition(): number {
    return this.get('position');
  }

  getItems(): PageItem[] {
    const items = this.get('items', []) as PageItem[];
    return items.sort((itemA, itemB) => itemA.getPosition() - itemB.getPosition());
  }

  isEmpty(): boolean {
    return this.getItems().length === 0;
  }

  getQuestions(): Question[] {
    return this.getItems().filter((item) => item instanceof Question) as Question[];
  }

  getDiscreteQuestions(): (Question & DiscreteQuestion)[] {
    return this.getQuestions().filter(
      (question) =>
        question.getKind() !== PageItemKind.QuestionCommentsBox &&
        question.getKind() !== PageItemKind.QuestionForm
    ) as (Question & DiscreteQuestion)[];
  }
}
